import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import CustomInput from '../CommonComp/CustomInput/CustomInput';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import { editSimilarImageKeyword } from '../../Services/keywordsApis';
import { action, logsMessagesList, modulesNames } from '../../data/logsMessages';
import { adminAddLogs } from '../../Services/commonService';

function EditSimilarImageKeyword({ open, handleOpen, getListing, selectedData }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (values, { resetForm }) => {
    setLoading(true);

    const payload = {
      similarkeyword_id: selectedData?.sno,
      visible_keyword_id: Number(values.visible_keyword_id),
      visible_keyword_name: values.visible_keyword_name,
    };

    try {
      const resp = await editSimilarImageKeyword(payload);
      if (resp) {
        const payloadForLogs = {
          action: action?.update,
          module: modulesNames?.keywords,
          description: logsMessagesList?.keyword?.keywordSimilarImageEdit,
        };
        await adminAddLogs(payloadForLogs);
        resetForm();
        getListing();
        handleOpen(false);
      }
    } catch (error) {
      console.error('API Error:', error);
    }

    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      visible_keyword_id: selectedData?.visible_keyword_id ?? '',
      visible_keyword_name: selectedData?.visible_keyword ?? '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      visible_keyword_id: Yup.mixed().required('Visible keyword id is required.'),
      visible_keyword_name: Yup.string().required('Visible keyword name is required.'),
    }),
    onSubmit: handleConfirm,
  });

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={() => handleOpen(false)}
      fullWidth
    >
      <DialogTitle variant="h3">Edit Similar Image Keyword</DialogTitle>
      <DialogContent>
        <Box
          noValidate
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                variant="outlined"
                fullWidth
                name="visible_keyword_id"
                label="Visible Keyword ID"
                placeholder="Enter Visible Keyword ID"
                value={formik.values.visible_keyword_id}
                onChange={formik.handleChange}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    notchedOutline: 'rounded',
                  },
                }}
                error={
                  formik.touched.visible_keyword_id &&
                  Boolean(formik.errors.visible_keyword_id)
                }
                helperText={
                  formik.touched.visible_keyword_id &&
                  formik.errors.visible_keyword_id
                }
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                variant="outlined"
                fullWidth
                name="visible_keyword_name"
                label="Visible Keyword"
                placeholder="Enter Visible Keyword"
                value={formik.values.visible_keyword_name}
                onChange={formik.handleChange}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    notchedOutline: 'rounded',
                  },
                }}
                error={
                  formik.touched.visible_keyword_name &&
                  Boolean(formik.errors.visible_keyword_name)
                }
                helperText={
                  formik.touched.visible_keyword_name &&
                  formik.errors.visible_keyword_name
                }
              />
            </Grid>
          </Grid>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
            <CustomButton color="buttonPrimary" type="submit" loading={loading}>
              Confirm
            </CustomButton>
            <CustomButton
              onClick={() => {
                formik.resetForm();
                handleOpen(false);
              }}
              disabled={loading}
              style={{ marginLeft: 10 }}
            >
              Cancel
            </CustomButton>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default EditSimilarImageKeyword;
